// Anonymous, lightweight identity for a browser session — used to dedupe clicks
// and throttle submissions without any login. Cleared/evadable by design; the
// server pairs it with a hashed IP for abuse signals.

/** Stable anonymous id for this browser (created on first use). */
export function getSessionId() {
  try {
    let id = localStorage.getItem('uhcs_sid');
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem('uhcs_sid', id);
    }
    return id;
  } catch {
    return null; // localStorage/crypto unavailable (privacy mode, etc.)
  }
}

/** Fire-and-forget: record a click on a server. Never blocks navigation.
 *  Dedupes per (server, session): one browser can count once per server, and
 *  can still count clicks on many different servers in the same session. */
export function recordClick(serverId) {
  const sessionId = serverId && getSessionId();
  if (!sessionId) return;
  try {
    fetch('/api/click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: serverId, sessionId }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}

/** Report a server. Resolves true if the report was accepted. */
export async function reportServer(serverId, reason) {
  const sessionId = serverId && getSessionId();
  if (!sessionId) return false;
  try {
    const res = await fetch('/api/report', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ serverId, reason, sessionId }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
